import { render, staticRenderFns } from "./Filepage.vue?vue&type=template&id=2553816f"
import script from "./Filepage.vue?vue&type=script&lang=js"
export * from "./Filepage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports